import React from 'react';
import { motion } from 'framer-motion';
import { Network, Share2, LockOpen } from 'lucide-react';
export function IntegrationSlide() {
  return <div className="h-full w-full flex flex-col items-center justify-center px-8 bg-slate-950" data-id="element-61">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.6
    }} className="text-center mb-16" data-id="element-62">
        <div className="inline-flex items-center justify-center p-4 bg-blue-500/10 rounded-full mb-8" data-id="element-63">
          <Network className="w-12 h-12 text-blue-500" data-id="element-64" />
        </div>
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-6" data-id="element-65">
          Open Ecosystem
        </h2>
        <p className="text-2xl text-slate-400 max-w-3xl mx-auto" data-id="element-66">
          We play nice with everyone. No walled gardens.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl w-full" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="bg-slate-900 p-8 rounded-2xl border border-slate-800 text-center" data-id="element-68">
          <Share2 className="w-10 h-10 text-blue-400 mx-auto mb-6" data-id="element-69" />
          <h3 className="text-xl font-bold text-white mb-3" data-id="element-70">OCPP Standards</h3>
          <p className="text-slate-400" data-id="element-71">
            Built on open standards to ensure compatibility with all modern
            charging hardware.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="bg-slate-900 p-8 rounded-2xl border border-slate-800 text-center relative overflow-hidden" data-id="element-72">
          <div className="absolute top-0 right-0 p-2 bg-blue-600 text-xs font-bold text-white rounded-bl-xl" data-id="element-73">
            PARTNERS
          </div>
          <Network className="w-10 h-10 text-green-400 mx-auto mb-6" data-id="element-74" />
          <h3 className="text-xl font-bold text-white mb-3" data-id="element-75">
            Major Integrations
          </h3>
          <p className="text-slate-400" data-id="element-76">
            Pre-built integrations with major players like Ampeco and other CPMS
            providers.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="bg-slate-900 p-8 rounded-2xl border border-slate-800 text-center" data-id="element-77">
          <LockOpen className="w-10 h-10 text-purple-400 mx-auto mb-6" data-id="element-78" />
          <h3 className="text-xl font-bold text-white mb-3" data-id="element-79">
            No Vendor Lock-in
          </h3>
          <p className="text-slate-400" data-id="element-80">
            Maintain full control of your infrastructure and data. Switch
            providers whenever you need.
          </p>
        </motion.div>
      </div>
    </div>;
}